// Grid.js

// Componente Row
function Row({ children, className, ...props }) {
    return (
      <div className={`flex flex-wrap -mx-2 ${className}`} {...props}>
        {children}
      </div>
    );
  }
  
  // Componente Col
  function Col({ children, className, xs, sm, md, lg, xl, xxl, ...props }) {
    const colClasses = [
      xs ? `w-full ${xs}` : "w-full",
      sm ? `sm:${sm}` : "",
      md ? `md:${md}` : "",
      lg ? `lg:${lg}` : "",
      xl ? `xl:${xl}` : "",
      xxl ? `xxl:${xxl}` : "",
    ]
      .filter(Boolean)
      .join(" ");
  
    return (
      <div className={`px-2 ${colClasses} ${className}`} {...props}>
        {children}
      </div>
    );
  }
  
  // Componente Grid che utilizza Row e Col
  function Grid({ children, className, ...props }) {
    return (
      <div className={`grid-container ${className}`} {...props}>
        {children}
      </div>
    );
  }
  
  export { Grid, Row, Col };
  